/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PerformanceCargoClassRow
 */
export interface PerformanceCargoClassRow {
  /**
   *
   * @type {string}
   * @memberof PerformanceCargoClassRow
   */
  freightClass: string;
  /**
   *
   * @type {number}
   * @memberof PerformanceCargoClassRow
   */
  count: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceCargoClassRow
   */
  booked: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceCargoClassRow
   */
  averageWeightLbs: number;
}

/**
 * Check if a given object implements the PerformanceCargoClassRow interface.
 */
export function instanceOfPerformanceCargoClassRow(
  value: object,
): value is PerformanceCargoClassRow {
  if (!("freightClass" in value) || value["freightClass"] === undefined)
    return false;
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("booked" in value) || value["booked"] === undefined) return false;
  if (!("averageWeightLbs" in value) || value["averageWeightLbs"] === undefined)
    return false;
  return true;
}

export function PerformanceCargoClassRowFromJSON(
  json: any,
): PerformanceCargoClassRow {
  return PerformanceCargoClassRowFromJSONTyped(json, false);
}

export function PerformanceCargoClassRowFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerformanceCargoClassRow {
  if (json == null) {
    return json;
  }
  return {
    freightClass: json["freightClass"],
    count: json["count"],
    booked: json["booked"],
    averageWeightLbs: json["averageWeightLbs"],
  };
}

export function PerformanceCargoClassRowToJSON(
  json: any,
): PerformanceCargoClassRow {
  return PerformanceCargoClassRowToJSONTyped(json, false);
}

export function PerformanceCargoClassRowToJSONTyped(
  value?: PerformanceCargoClassRow | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    freightClass: value["freightClass"],
    count: value["count"],
    booked: value["booked"],
    averageWeightLbs: value["averageWeightLbs"],
  };
}
